<template>
  <v-theme-provider dark>
    <base-section
      id="contact-us"
      class="primary"
      space="40"
    >
      <v-container>
        <v-row justify="center">
          <v-col cols="10">
            <base-title
              :space="$vuetify.breakpoint.mdAndUp ? 0 : 4"
              title="HAVE QUESTIONS? LET US KNOW!"
            />

            <base-body space="0">
              <span class="white--text">
                If you'd like to learn more by contacting on of the C.A.T. members, please use the Contact Us to email us, and we'll get back to you.<br>Or email to info@climateactiontruro.org

                <br><br>
                You can also <a
                  href="https://us02web.zoom.us/j/5905059484?pwd=YXZndlBpSlBGWGNXTGsvVWpQWG9RUT09"
                  target="_blank"
                  style="color:purple"
                >login to our next Zoom meetup</a> which is held approximately weekly.
              </span>
            </base-body>
          </v-col>

          <v-col
            cols="12"
            md="2"
          >
            <!--
            href="mailto:info@climateactiontruro.org?subject=Question from CAT website"
            -->
            <base-btn
              :block="$vuetify.breakpoint.smAndDown"
              color="white"
              href="mailto:beboyle@aol.com?subject=Question from CAT website"
              large
              outlined
              target="_blank"
            >
              Contact Us
            </base-btn>
          </v-col>
        </v-row>
      </v-container>
    </base-section>
  </v-theme-provider>
</template>

<script>
  export default {
    name: 'SectionContactUs',
  }
</script>

<style>

</style>
